import themeApi from '@/api/theme'
import { sanitizeHTML } from '@/utils/dom'

const state = {
  css: '',
  logo: '',
  favicon: '',
  serviceName: '',
  copyright: '',
  cognito: {
    userPoolId: '',
    clientId: ''
  }
}

const getters = {
  cleanCopyright: state => sanitizeHTML(state.copyright)
}

const mutations = {
  SET_THEME(state, payload) {
    state.css = payload.css
    state.favicon = payload.favicon
    state.logo = payload.logo_image
    state.serviceName = payload.service_name
    state.copyright = payload.copyright
    state.cognito = {
      userPoolId: payload.cognito_user_pool_id,
      clientId: payload.cognito_client_id
    }
  }
}

const actions = {
  async fetch({ commit }) {
    const response = await themeApi.get()
    commit('SET_THEME', response.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
